/* Altura do arquivo individual em Full. A tela continua em 350; o arquivo é o dobro. */
export const INDIVIDUAL_FULL_EXPORT_HEIGHT = 700

export type IndividualFullExportOptionsTP = {
    sourceWidth: number,
    sourceHeight: number,
    scale: number,
}

/**
 * Tamanho do arquivo individual em Full: largura da tela vezes 2, altura 700.
 * scale 1 evita que o Highcharts dobre de novo o PNG, o JPEG e o PDF.
 */
export function individualFullExportOptions(chartWidth: number): IndividualFullExportOptionsTP {
    return {
        sourceWidth: chartWidth * 2,
        sourceHeight: INDIVIDUAL_FULL_EXPORT_HEIGHT,
        scale: 1,
    }
}
